module.exports = __webpack_public_path__ + "static/media/Lateral_Moderate_Z2.42311a7e.png";